var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.anchorName,staticClass:"anchor-area"},[_vm._t("content",function(){return [_vm._v("锚点区域")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }